import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import EditTabSettings from '../../../inputs/EditTabSettings';
import EditEstimates from './EditEstimates';
import TabEditTabProperties from './TabEditTabProperties';
import EditTabCheckboxes from './EditTabCheckboxes';
import EditInspection from './EditInspection';
import EditSuperForm from './EditSuperForm';
import EditTabCost from './EditTabCost';
import MpiFormBuilderSettings from './MpiFormBuilderSettings';
import TabPluginToggles from './TabPluginToggles';
import EditUsedCarChecklist from './EditUsedCarChecklist';
import EditVehicleHistory from './EditVehicleHistory';
import { change_page } from '../../../actions/toggleMenu';

const TabSettingsEdit = (props) => {
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({ editTab: false });
    const [optionName, setOptionName] = useState('');
    const all_tabs = useSelector(state => state.settings_site.all_tabs);
    const edit_tab = useSelector(state => state.settings_admin.edit_tab);
    
    const onBackClick = () => {
        dispatch(change_page('group-settings'));
    };

    const getTabByName = () => {
        const value = _.sortBy(_.filter(all_tabs, o => o.name === (props.edit_tab != '' ? props.edit_tab : edit_tab)), 'id');
        return value[0];
    };

    const tab = getTabByName();


    return (
        <div className="container-fluid">
				<div className="col-md-12">
            <div className="card space-top-0">
                <h3 className="text-center pad-top-1">
                    {edit_tab.replace('tab_', '')} Settings
                </h3>

                <div className="card bg-light space-bottom-1 space-top-1">
                    <div className="card space-top-1">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <EditTabSettings
                                        type={'number-prepend'}
                                        name={'order'}
                                        value={tab.order}
                                        dataid={tab.id}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-column">
									<div className="p-2 list-group setscroll">
                    {(() => {
                        switch (props.edit_tab) {
                            case 'tab_estimate':
                                return <EditEstimates tab={tab} />;
                            case 'tab_checkboxes':
                                return <EditTabCheckboxes tab={tab} />;
                            case 'tab_inspection':
                                return <EditInspection tab={tab} />;
                            case 'tab_mpi_form_builder':
                                return <MpiFormBuilderSettings tab={tab} />;
                            case 'tab_superform':
                                return <EditSuperForm tab={tab} />;
                            case 'tab_cost':
                                return <EditTabCost tab={tab} />;
                            case 'tab_history':
                                return <EditVehicleHistory tab={tab} />;
                            case 'tab_used_car_checklist':
                                return <EditUsedCarChecklist tab={tab} />;
                            default:
                                return '';
                        }
                    })()}
                    </div>
                    </div>
                    <div className="col-md-12">{tab ? <TabPluginToggles tab={tab} /> : ''}</div>
                    <div className="col-md-12">{tab ? <TabEditTabProperties tab={tab} edit_tab={props.edit_tab != '' ? props.edit_tab : edit_tab} /> : ''}</div>
                </div>
            </div>
        </div>
     </div>
    );
};

export default TabSettingsEdit;